<script setup lang="ts">
import { IconCheck, IconSelector } from "@tabler/icons-vue";
import { PopoverRoot as Popover, PopoverTrigger } from "reka-ui";
import { ref } from "vue";
import { RouterLink } from "vue-router";
import Button from "@/components/ui/button/Button.vue";
import Command from "@/components/ui/command/Command.vue";
import CommandEmpty from "@/components/ui/command/CommandEmpty.vue";
import CommandGroup from "@/components/ui/command/CommandGroup.vue";
import CommandInput from "@/components/ui/command/CommandInput.vue";
import CommandItem from "@/components/ui/command/CommandItem.vue";
import CommandList from "@/components/ui/command/CommandList.vue";
import PopoverContent from "@/components/ui/popover/PopoverContent.vue";
import { useWorkspacesStore } from "@/stores/workspaces";

const workspacesStore = useWorkspacesStore();

const open = ref(false);
</script>

<template>
	<Popover v-model:open="open">
		<PopoverTrigger as-child>
			<Button
				variant="outline"
				role="combobox"
				:aria-expanded="open"
				class="mt-1 mb-4 w-full [&>span:first-child]:w-full [&>span:first-child]:justify-between"
				:class="[$route.params.workspaceName ? '' : 'text-slate-500']"
			>
				{{ $route.params.workspaceName || "Select workspace..." }}
				<IconSelector class="ml-2 h-4 w-4 shrink-0 opacity-50" />
			</Button>
		</PopoverTrigger>
		<PopoverContent class="w-[14rem] p-0">
			<Command>
				<CommandInput class="h-9" placeholder="Search workspaces..." />
				<CommandEmpty>No workspaces found.</CommandEmpty>
				<CommandList>
					<CommandGroup>
						<CommandItem
							v-for="workspace in workspacesStore.workspaces"
							:key="workspace.id"
							:value="workspace.name"
							@select="open = false"
							as-child
						>
							<RouterLink :to="`/owner/${workspace.owner}/w/${workspace.name}`">
								{{ workspace.name }}
								<IconCheck
									:class="[
										'ml-auto h-4 w-4',
										$route.params.workspaceName === workspace.name
											? 'opacity-100'
											: 'opacity-0',
									]"
								/>
							</RouterLink>
						</CommandItem>
					</CommandGroup>
				</CommandList>
			</Command>
		</PopoverContent>
	</Popover>
</template>
